import * as React from 'react';

import classNames from 'classnames';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import { planAutoRenewDate } from 'bundles/teams-v2/components/utils';

import _t from 'i18n!nls/teams-v2';

import 'css!./__styles__/TeamsLegalDisclaimerItem';

const ORGANIZATION_AGREEMENT_LINK = 'https://www.coursera.org/about/terms-for-enterprise';
const TERMS_OF_USE_LINK = 'https://www.coursera.org/about/terms';
const PRIVACY_POLICY_LINK = 'https://www.coursera.org/about/privacy';

type PropsToComponent = {
  isDiscounted?: boolean;
};

const TeamsLegalDisclaimerItem = ({ isDiscounted }: PropsToComponent) => {
  const legal = isDiscounted
    ? _t(
        `By confirming this purchase, I agree to the {courseraOrganizationsAgreement}. 
    Your annual subscription begins today. If you decide to stop auto-renewal, 
    visit your plan Account page to cancel before {planAutoRenewDate} and your 
    subscription won't renew. If you would like to cancel your current plan, 
    you have 14 days to request a full refund from the date of purchase. 
    Check your confirmation email for details. If you received an offer for reduced pricing, 
    this pricing may not be available upon renewal or when adding new licenses. 
    Coursera may also share aggregate data back to affiliate partners to evaluate 
    the effectiveness of the partnership.`
      )
    : _t(
        `By confirming this purchase, I agree to the {courseraOrganizationsAgreement}. 
    Your annual subscription begins today. If you decide to stop auto-renewal, 
    visit your plan Account page to cancel before {planAutoRenewDate} and your 
    subscription won't renew. If you would like to cancel your current plan, 
    you have 14 days to request a full refund from the date of purchase. 
    Check your confirmation email for details.`
      );

  return (
    <div className={classNames('rc-TeamsLegalDisclaimerItem', 'm-t-2', 'rc-TeamsLegalDisclaimerItem--padding')}>
      <p className="c-disclaimerText m-b-1">
        <FormattedMessage
          message={legal}
          courseraOrganizationsAgreement={
            <TrackedA
              trackingName="organizations_agreement_link"
              target="_blank"
              rel="noopener noreferrer"
              href={ORGANIZATION_AGREEMENT_LINK}
              className="c-disclaimerLink"
            >
              {_t('Coursera Organizations Agreement')}
            </TrackedA>
          }
          planAutoRenewDate={planAutoRenewDate}
        />
      </p>
      <p className="c-disclaimerText m-b-0">
        <FormattedMessage
          message={_t(`I understand I am also creating a new Coursera account. By signing up to create an account I accept
            Coursera's {termsOfUse} and {privacyPolicy}, including the {processingOfPersonalData}.`)}
          termsOfUse={
            <TrackedA
              trackingName="terms_of_use_link"
              target="_blank"
              rel="noopener noreferrer"
              href={TERMS_OF_USE_LINK}
              className="c-disclaimerLink"
            >
              {_t('Terms of Use')}
            </TrackedA>
          }
          privacyPolicy={
            <TrackedA
              trackingName="privacy_policy_link"
              target="_blank"
              rel="noopener noreferrer"
              href={PRIVACY_POLICY_LINK}
              className="c-disclaimerLink"
            >
              {_t('Privacy Policy')}
            </TrackedA>
          }
          processingOfPersonalData={
            <TrackedA
              trackingName="processing_data_link"
              target="_blank"
              rel="noopener noreferrer"
              href={PRIVACY_POLICY_LINK}
              className="c-disclaimerLink"
            >
              {_t('processing of your personal data in the United States')}
            </TrackedA>
          }
        />
      </p>
    </div>
  );
};

export default TeamsLegalDisclaimerItem;
